var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { Process } from "../../../../lib/process/process.cls";
import { WsConnector } from "../../../../lib/ws/ws-connector.cls";
var Buffer = require('buffer').Buffer;
var zlib = require('zlib');
var PriceFeedSeeder = /** @class */ (function (_super) {
    __extends(PriceFeedSeeder, _super);
    function PriceFeedSeeder(iProvider) {
        var _this = _super.call(this, iProvider) || this;
        /**
         * HTML5 WebSocket wrapper
         */
        _this.wsConnector = null;
        _this.onopen = function (ev) {
            // this.log(PriceFeedSeeder.TAG, 'open connection at url' + 
            //   this.settings.ENDPOINT) 
            try {
                _this.auth({ auth: _this.iProvider.settings.token,
                    defaults: _this.settings.defaultIsinIds });
            }
            catch (ex) { }
        };
        /**
         * handle message from webocket
         */
        _this.heartbeat = 0;
        _this.onmessage = function (ev) {
            try {
                var _that_1 = _this;
                var responseBuffer = new Buffer(ev.data, 'base64');
                zlib.unzip(responseBuffer, function (err, buffer) {
                    if (!err) {
                        var jsonMsg = JSON.parse(buffer.toString());
                        if (Object.keys(jsonMsg).length != 0) {
                            // this.log(PriceFeedSeeder.TAG, 'onmessage', jsonMsg)
                            if ('isins' in jsonMsg) {
                                if ('subscribe' in jsonMsg) {
                                    // add the array of isin-ids to the cache
                                    _that_1.iProvider.addItems(jsonMsg);
                                    return;
                                }
                                else if ('unsubscribe' in jsonMsg) {
                                    // remove the array of isin-ids from the cache
                                    _that_1.iProvider.patchItems(jsonMsg, false);
                                }
                                else if ("topLooser" in jsonMsg || "topGainer" in jsonMsg) {
                                    _that_1.iProvider.patchItem('topGainer', jsonMsg);
                                    _that_1.iProvider.patchItem('topLooser', jsonMsg);
                                }
                                return;
                            }
                            else {
                                _that_1.iProvider.patchItems(jsonMsg);
                            }
                        }
                    }
                });
            }
            catch (exo) {
                _this.log(PriceFeedSeeder.TAG, 'onmessage EXC', exo);
            }
        };
        _this.onclose = function (ev) {
            _this.log(PriceFeedSeeder.TAG, 'onclose...', ev);
        };
        _this.onerror = function (ev) {
            _this.log(PriceFeedSeeder.TAG, 'onerror...', ev);
        };
        _this.onconnecting = function () {
            _this.log(PriceFeedSeeder.TAG, 'onconnecting...');
        };
        return _this;
    }
    PriceFeedSeeder.prototype.sendMessage = function (jsonMsg) {
        try {
            this.wsConnector.send(JSON.stringify(jsonMsg));
        }
        catch (ex) {
            this.log(PriceFeedSeeder.TAG, 'sendMessage EXC', { jsonMsg: jsonMsg, ex: ex.message });
        }
    };
    /**
     * @Override
     * authenticate using the credentials inside params
     * @param params
     */
    PriceFeedSeeder.prototype.auth = function (params) {
        try {
            this.sendMessage(params);
        }
        catch (ex) {
            this.log(PriceFeedSeeder.TAG, 'auth [ex]', ex.message);
        }
    };
    /**
     * @Override
     * subscribe tp a resource
     * @param ids either an array of ids or a key -> objecr mapping
     */
    PriceFeedSeeder.prototype.subscribe = function (ids) {
        ids = (ids instanceof Array) ? ids : this.mapping2keys(ids);
        this.sendMessage({ subscribe: ids });
        this.iProvider.heartbeat();
    };
    /**
     * @Override
     * authenticate using the credentials inside params
     * @param params
     */
    PriceFeedSeeder.prototype.unsubscribe = function (ids) {
        ids = (ids instanceof Array) ? ids : this.mapping2keys(ids);
        this.sendMessage({ unsubscribe: ids });
        this.iProvider.patchItems(ids, true);
    };
    PriceFeedSeeder.prototype.closeWs = function (params) {
        try {
            this.wsConnector.stop(params);
        }
        catch (ex) {
            this.log('closing websocket', ex.message);
        }
    };
    /**
     * start process thread
     * used by caches and providers and mains to start all
     * registered providers and caches
     * @param params
     */
    PriceFeedSeeder.prototype.start = function (params) {
        this.settings = params;
        try {
            this.settings.onopen = this.onopen;
            this.settings.onclose = this.onclose;
            this.settings.onconnecting = this.onconnecting;
            this.settings.onmessage = this.onmessage;
            this.wsConnector = new WsConnector();
            this.wsConnector.start(this.settings);
        }
        catch (ex) {
            this.log(PriceFeedSeeder.TAG, 'start [ex]', ex);
        }
    };
    /**
     * stop process thread
     * used by caches and providers and mains to stop all
     * registered providers and caches
     * @param params
     */
    PriceFeedSeeder.prototype.stop = function (params) {
        try {
            this.closeWs(params);
        }
        catch (ex) {
            this.log(PriceFeedSeeder.TAG, "stop [ex]", ex);
        }
    };
    PriceFeedSeeder.TAG = 'PriceFeedSeeder';
    return PriceFeedSeeder;
}(Process));
export { PriceFeedSeeder };



//////////////////
// WEBPACK FOOTER
// ./src/plugins/vue-provider-cache/provider/ws-price-feed/seeder/price-feed-seeder.cls.ts
// module id = null
// module chunks = 